import { createAction, props } from '@ngrx/store';

export const GetFormularios = createAction(
  '[Formularios] Get Formularios',
);

export const GetFormulariosSuccess = createAction(
  '[Formularios] Get Formularios Success',
  props<{ formularios: any[] }>()
);

export const CreateFormulario = createAction(
  '[Formularios] Create Formulario',
  props<{ formularios: any }>()
);

export const CreateFormularioSuccess = createAction(
  '[Formularios] Create Formulario Success',
  props<{ formularios: any }>()
);

export const DeleteFormulario = createAction(
  '[Formularios] Delete Formulario',
  props<{ id: string }>()
);

export const DeleteFormularioSuccess = createAction(
  '[Formularios] Delete Formulario Success',
  props<{ formularios: any }>()
);

export const UpdateFormulario = createAction(
  '[Formularios] Update Formulario',
  props<{ id: string, formularios: any }>()
);

export const UpdateFormularioSuccess = createAction(
  '[Formularios] Update Formulario Success',
  props<{ formularios: any }>()
);

export const GetFormulariosAsignados = createAction(
  '[Formularios] Get Formularios Asignado',
  props<{ id: string }>()
);

export const GetFormulariosAsignadosSuccess = createAction(
  '[Formularios] Get Formularios Asignado Success',
  props<{ formulariosAsignados: any[] }>()
);

export const CreateFormularioAsignados = createAction(
  '[Formularios] Create Formulario Asignado',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioAsignadosSuccess = createAction(
  '[Formularios] Create Formulario Asignado Success',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioGrupo = createAction(
  '[Formularios] Create Formulario Grupo',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioGrupoSuccess = createAction(
  '[Formularios] Create Formulario Grupo Success',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioCentro = createAction(
  '[Formularios] Create Formulario Centro',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioCentroSuccess = createAction(
  '[Formularios] Create Formulario Centro Success',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioPrograma = createAction(
  '[Formularios] Create Formulario Programa',
  props<{ formulariosAsignados: any }>()
);

export const CreateFormularioprogramaSuccess = createAction(
  '[Formularios] Create Formulario Programa Success',
  props<{ formulariosAsignados: any }>()
);

export const GetFormularioResponses = createAction(
  '[Formularios] Get Formularios Responses',
  props<{ id: string }>()
);

export const GetFormularioResponsesSuccess = createAction(
  '[Formularios] Get Formularios Responses Success',
  props<{ formularioResponses: any[] }>()
);